import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { bonusesTotal, pricing } from '../data/content';
import { formatArs } from '../utils/format';
interface OfferProps {
  showCountdown: boolean;
}
const included = ['Tomo 1 — Poné en orden tu dinero', 'Tomo 2 — Ahorrá aunque ganes poco', 'Tomo 3 — Deudas bajo control', 'Tomo 4 — Construí tu fondo de emergencia', 'Tomo 5 — Hacé crecer tus ahorros', 'Tomo 6 — Tu transformación en 12 meses'];
export function Offer({
  showCountdown
}: OfferProps) {
  return <section id="comprar" className="w-full bg-forest-deep" data-id="element-155" data-mp="13wrb3nlb0gog">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-156" data-mp="13uy58aiim0hi">
        <div className="grid gap-10 lg:grid-cols-[1fr_25rem] lg:gap-16" data-id="element-157" data-mp="yx52xskc1qmi">
          <div data-id="element-158" data-mp="2fbeqikgr3bca">
            <h2 className="font-display text-3xl font-black leading-tight text-cream sm:text-4xl lg:text-5xl" data-id="element-159" data-mp="2fav6my7jicvm">
              Todo el sistema, en un solo pago
            </h2>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-cream/75" data-id="element-160" data-mp="pkqnc8hm1r98">
              Los 6 tomos completos más los 6 bonus prácticos, en PDF, para
              descargar y usar hoy mismo. Sin suscripción y sin vencimiento de
              acceso.
            </p>

            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-161" data-mp="13k02d4u2yfbm">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-cream/85" data-id="element-162" data-mp="13hvz8p409kce">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-163" data-mp="6vk9ayrrhntr" />
                  {item}
                </li>)}
              <li className="flex items-start gap-2.5 text-sm font-semibold text-cream sm:col-span-2" data-id="element-164" data-mp="ftvzizopujlo">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-165" data-mp="klntlk72z7gk" />
                Los 6 bonus completos ({formatArs(bonusesTotal)}) incluidos
              </li>
            </ul>

            {showCountdown ? <div className="mt-10 flex flex-wrap items-center gap-5 border-t border-white/10 pt-8" data-id="element-166" data-mp="3o960g4gvdirv">
                <div data-id="element-167" data-mp="vefsw15ns30k">
                  <p className="font-display text-sm font-bold uppercase tracking-wide text-gold" data-id="element-168" data-mp="vdwcwpzkjop6">
                    Precio de lanzamiento
                  </p>
                  <p className="mt-1 text-sm text-cream/60" data-id="element-169" data-mp="154ijxvt7z6w9">
                    Termina hoy a la medianoche
                  </p>
                </div>
                <Countdown data-id="element-170" data-mp="108th9jlwl9vq" />
              </div> : null}
          </div>

          <div className="rounded-2xl bg-cream p-7 shadow-card lg:p-8" data-id="element-171" data-mp="chel68kpzosx">
            <p className="font-display text-xs font-bold uppercase tracking-wide text-ink-muted" data-id="element-172" data-mp="7il4k7a4zhoj">
              Sistema de Ahorro completo
            </p>
            <h3 className="mt-2 font-display text-2xl font-extrabold leading-snug text-ink" data-id="element-173" data-mp="lf866nd1aw0s">
              6 tomos + 6 bonus
            </h3>

            <div className="mt-6 flex items-end gap-3" data-id="element-174" data-mp="1wvyd68pa7rvg">
              <p className="font-display text-5xl font-black leading-none text-forest" data-id="element-175" data-mp="1wyknuh7gynhw">
                {formatArs(pricing.price)}
              </p>
              <p className="pb-1 text-sm font-semibold text-ink-muted" data-id="element-176" data-mp="20dm31xqr0e1c">
                {pricing.currency}
              </p>
            </div>
            <p className="mt-2 text-sm text-ink-muted" data-id="element-177" data-mp="25bnqeuv7izim">
              Precio habitual{' '}
              <span className="line-through" data-id="element-178" data-mp="1qikhfbvolu3i">{formatArs(pricing.anchor)}</span> ·
              Pago único
            </p>

            <a href="#comprar" className="mt-7 flex w-full items-center justify-center rounded-lg bg-forest px-6 py-4 font-display text-base font-extrabold uppercase tracking-wide text-cream transition-colors duration-150 ease-out hover:bg-forest-soft" data-id="element-179" data-mp="2j55624krvs3d">
              Quiero el sistema
            </a>

            <ul className="mt-6 space-y-2.5 border-t border-line pt-6 text-sm text-ink-muted" data-id="element-180" data-mp="2eeez4mwp7h6k">
              <li className="flex items-center gap-2" data-id="element-181" data-mp="323znjlbmf6n8">
                <ShieldCheckIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-182" data-mp="322g6vtm1ytkx" />
                Garantía de 7 días, devolución del 100%
              </li>
              <li className="flex items-center gap-2" data-id="element-183" data-mp="1j6xorhiuwh1r">
                <LockIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-184" data-mp="1j4bg1ek8bvhy" />
                Pago seguro y acceso inmediato
              </li>
              <li className="flex items-center gap-2" data-id="element-185" data-mp="197oxiwfdlgj3">
                <CreditCardIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-186" data-mp="19ab3wsqj5pzq" />
                Mercado Pago, tarjeta o transferencia
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}